export const SHORTAGES_INDEX = {
  shortageDisputes: 'sd-asinDetailMetrics'
};
